<template>
  <div class>
    <v-card class="pa-5" flat>
      <h1 class="fonte text-uppercase">Filtros das Campanhas</h1>
      <v-layout row wrap pt-3>
        <v-flex xs3 pr-3 pt-1>
          <span class="caption">Data Inicial</span>
          <datetime
            type="datetime"
            class="subheading"
            v-model="filtro.dataInicial"
            :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
            format="dd/MM/yyyy HH:mm"
          ></datetime>
        </v-flex>
        <v-flex xs3 pr-3 pt-1>
          <span class="caption font-weight-regular">Data Final</span>
          <datetime
            type="datetime"
            class="subheading"
            v-model="filtro.dataFinal"
            :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
            format="dd/MM/yyyy HH:mm"
          ></datetime>
        </v-flex>
        <v-flex xs3 pr-3>
          <v-text-field label="Nome da campanha" v-model="filtro.nome" color="teal"></v-text-field>
        </v-flex>
        <v-flex xs3 pr-3>
          <v-select
            v-model="filtro.status"
            :items="getAllStatusAgendamento()"
            item-text="descricao"
            item-value="status"
            label="Filtro por status"
            multiple
            color="teal"
          ></v-select>
        </v-flex>
        <v-flex xs3 pr-3>
          <v-select
            v-model="filtro.templateMailing"
            :items="getTemplatesCampanha"
            no-data-text="Nenhuma campanha encontrada"
            item-text="nome"
            item-value="_id"
            label="Escolha o mailing"
            color="teal"
          ></v-select>
        </v-flex>

        <v-flex xs2>
          <v-btn
            :loading="isLoadingBusca"
            :disabled="isLoadingBusca"
            color="fundo"
            @click="getAgendamentos"
            block
            large
            round
          >
            <v-icon left>search</v-icon>Pesquisar
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon light>cached</v-icon>
              </span>
            </template>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
    <v-divider></v-divider>
    <v-card flat class="pa-5">
      <h1 class="fonte text-uppercase">Agendamentos</h1>
      <v-data-table
        :headers="headers"
        :items="getUltimosAgendamentos"
        hide-actions
        :loading="isLoadingBusca"
        :expand="expand"
        item-key="_id"
        no-data-text="Nenhum dado encontrado"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ formatData(props.item.createdAt, props.item.timezone) }}</td>
          <td class="text-xs-center">{{ props.item.nome || "Campanha sem nome" }}</td>
          <td class="text-xs-center">{{ formatDataHora(props.item.date, props.item.timezone) }}</td>
          <td class="text-xs-center">{{ props.item.templateMailing[0].nome }}</td>
          <td class="text-xs-center">{{ props.item.templateMailing[0].qtdLinhas }}</td>
          <td class="text-xs-center">
            <v-chip
              :color="corStatus(alteraStatusAgendamento(props.item.status).status)"
              text-color="white"
            >{{alteraStatusAgendamento(props.item.status).status}}</v-chip>
          </td>
          <td class="text-xs-center">
            <v-btn color="fundo" fab small depressed @click="showAgendamento(props.item)">
              <v-icon>insert_chart</v-icon>
            </v-btn>
          </td>
          <td class="text-xs-center">
            <v-btn
              color="fundo"
              :disabled="props.item.status != 2"
              fab
              small
              depressed
              @click="props.expanded = !props.expanded, props.expanded == true ? showMensagensErro(props.item) : ''"
            >
              <v-icon>sms_failed</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:expand="props">
          <v-card flat>
            <v-toolbar dark color="fundo">
              <v-toolbar-title>Reenvios</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <div v-if="loadErros" class="pa-3">
              <h1 class="fonte">Carregando status das mensagens...</h1>
              <v-progress-linear :indeterminate="true"></v-progress-linear>
            </div>

            <v-card-text v-if="!loadErros">
              <div v-if="getErros.length > 0">
                <h1 class="fonte pb-3">Informes de erros</h1>
                <div class="pb-3 flex-container">
                  <p
                    class="headline pr-4"
                    v-for="(st, i) in getErros"
                    :key="i"
                  >{{statusSMS(st.status).status + ': ' + st.total}}</p>
                </div>
                <div class="pb-3">
                  <h1 class="fonte pb-3">Detalhes da campanha</h1>
                  <v-flex xs4>
                  <v-alert :value="true" color="error" icon="warning" outline>Os status em vermelho são inválidos.</v-alert>
                  </v-flex>
                  <v-flex xs3>
                    <v-data-table
                      :items="getMensagensErro.filter(ms => getErros.filter(st => ms.status == st.status ))"
                      class="elevation-1"
                      :headers="headersReenvio"
                      hide-actions
                    >
                      <template v-slot:items="props">
                        <td
                          :class="props.item.status > 511 ? 'red text-xs-center' : 'text-xs-center'"
                        >
                            <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <span v-on="on" style="cursor: pointer;">{{ props.item.status }}</span>
                            </template>
                            <span class="body-2">{{ statusSMS(props.item.status).status }}</span>
                            </v-tooltip>
                        </td>
                        <td class="text-xs-center">{{ props.item.phone}}</td>
                      </template>
                    </v-data-table>
                  </v-flex>
                </div>
                <h1 class="fonte">Opções de Reenvio</h1>
                <v-flex xs4 pb-3>
                  <v-select
                    color="teal"
                    v-model="statusAtual"
                    :items="getErros"
                    item-text="text"
                    item-value="status"
                    multiple
                  ></v-select>
                </v-flex>
                <v-flex xs4 v-if="statusInvalido" pb-3>
                  <v-alert :value="true" type="error">{{message}}</v-alert>
                </v-flex>
                <v-flex xs2 v-if="statusAtual" pb-3>
                  <v-btn :disabled="statusAtual.length == 0" color="fundo" block large round @click="reenvioCampanha">
                    <v-icon left>send</v-icon>Reenviar
                    <template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template>
                  </v-btn>
                </v-flex>
              </div>
              <div v-else class="pt-3 pb-3">
                <h1 class="fonte">Essa campanha não possui erros válidos para reenvio</h1>
              </div>
            </v-card-text>
          </v-card>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogShowAgendamento" max-width="600">
      <v-card>
        <v-card-title class="headline">Status do agendamento</v-card-title>
        <v-card-text v-if="Object.keys(agendamentoSelected).length > 0">
          <p>Nome: {{ agendamentoSelected.nome }}</p>
          <column-chart v-if="agendamentoSelected.dados" :data="agendamentoSelected.dados"></column-chart>

          <column-chart
            v-else
            :data="agendamentoSelected.dados"
            :messages="{empty: 'Sumário não contabilizado'}"
          ></column-chart>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="teal darken-1" flat @click="dialogShowAgendamento = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment-timezone";
import * as helpers from "./../../../helpers/helpers";
export default {
  data() {
    return {
      statusInvalido: false,
      expand: false,
      snackbar: false,
      message: "",
      loadErros: false,
      calendar1: false,
      calendar2: false,
      tiposFiltros: "",
      isLoadingBusca: false,
      disabledRight: false,
      dialogResponses: false,
      dialogShowAgendamento: false,
      statusAtual: null,
      agendamentoSelected: {},
      search: "",
      filtro: {
        dataInicial: moment(new Date()).format("YYYY-MM-DD") + "T00:00",
        dataFinal: moment(new Date()).format("YYYY-MM-DD") + "T23:59",
        hoje: moment(new Date()).format("YYYY-MM-DD"),
        templateMailing: "",
        status: [],
        page: 1,
        nome: ""
      },
      filtros: [
        { text: "Por data", value: "data" },
        { text: "Por Status", value: "status" },
        { text: "Por Mailing", value: "mailing" },
        { text: "Personalizado", value: "todos" }
      ],
      reenvio: {
          phone: [],
          text: ''
      },
      agendamentos: [],
      headersReenvio: [
        {
          text: "Status",
          value: "status",
          align: "center",
          sortable: false
        },
        {
          text: "Telefone",
          value: "phone",
          align: "center",
          sortable: false
        }
      ],
      headers: [
        {
          text: "Data de criação",
          value: "createdAt",
          align: "center",
          sortable: false
        },
        {
          text: "Nome da Campanha",
          value: "nome",
          align: "center",
          sortable: false
        },
        {
          text: "Data de envio",
          value: "date",
          align: "center",
          sortable: false
        },
        {
          text: "Nome do mailing",
          value: "templateMailing[0].nome",
          align: "center",
          sortable: false
        },
        {
          text: "Quantidade de linhas do arquivo",
          value: "templateMailing[0].qtdLinhas",
          align: "center",
          sortable: false
        },
        { text: "Status", value: "status", align: "center", sortable: false },
        { text: "Ver", value: "status", align: "center", sortable: false },
        { text: "Reenvio", value: "reenvio", align: "center", sortable: false }
      ]
    };
  },
  methods: {
    ...mapActions(["setUltimosAgendamentos", "arquivos_getReenvios", "arquivos_sendReenvios"]),
    async reenvioCampanha(){
        this.getMensagensErro.filter(_ => this.statusAtual.filter(st => {
            if(_.status == st && _.status < 512) {
                this.reenvio.phone.push({_id: _._id, phone: _.phone})
                this.reenvio.text = _.text
            }
        }))

        let result = await this.arquivos_sendReenvios(this.reenvio)


        if(result.status) {
            this.$eventHub.emit("snackBar", {message: result.mensagem})
            this.getAgendamentos()
            this.reenvio = {
                phone: [],
                text: ''
            }
        }

        //console.log(this.reenvio)
    },
    statusSMS(status) {
      return helpers.getStatusSms(status);
    },
    async showMensagensErro(item) {
      Object.assign(this.$data, this.$options.data.apply(this));
      this.loadErros = true;
      let resp = await this.arquivos_getReenvios(item._id);
      if (resp.status) this.loadErros = false;
    },
    getAllStatusAgendamento() {
      return helpers.getAllStatusAgendamento();
    },
    formatData(data, timezone) {
      return moment(data)
        .tz(timezone)
        .format("DD/MM/YYYY");
    },
    formatDataHora(data, timezone) {
      return moment(data)
        .tz(timezone)
        .format("DD/MM/YYYY HH:mm");
    },
    async next() {
      this.filtro.page++;
      let status = await this.getAgendamentos();
      if (!status) {
        this.filtro.page--;
        this.isLoadingBusca = false;
        this.$eventHub.emit("snackBar", {
          message: "Não tem dados na próxima página"
        });
      }
    },
    async arrow() {
      this.filtro.page--;
      await this.getAgendamentos();
    },
    async getAgendamentos() {
      this.isLoadingBusca = true;
      let resp = await this.setUltimosAgendamentos(this.filtro);
      this.isLoadingBusca = false;
      return resp;
    },
    alteraStatusAgendamento(status) {
      return helpers.getStatusAgendamento(status);
    },
    corStatus(status) {
      switch (status) {
        case "processado":
          return "green";
          break;
        case "processando":
          return "cyan darken-2";
          break;
        case "agendado":
          return "orange";
          break;

        default:
          return "grey";
          break;
      }
    },

    showAgendamento(agendamento) {
      this.dialogShowAgendamento = true;
      this.agendamentoSelected = agendamento;
      if (this.agendamentoSelected.sumary) {
        this.agendamentoSelected["dados"] = [
          {
            name: "Sucesso",
            data: { Sucesso: agendamento.sumary.sucesso },
            color: "#1976d2"
          },
          {
            name: "Erro",
            data: { Erro: agendamento.sumary.erro },
            color: "#f44336"
          }
        ];
      }
    }
  },
  computed: {
    ...mapGetters([
      "getUltimosAgendamentos",
      "getTemplatesCampanha",
      "getMensagensErro"
    ]),
    getErros() {
      let erros = [];
      this.getMensagensErro.filter(ms => {
        return erros.push({
          text: this.statusSMS(ms.status).status,
          status: ms.status,
          total: this.getMensagensErro.filter(hi => hi.status == ms.status)
            .length
        });
      });
      let unique = [];
      erros.forEach(re => {
        if (!unique.find(ff => re.status == ff.status)) {
          unique.push(re);
        }
      });

      let validos = [];
      validos = unique.filter(u => u.status < 512);
      return validos;
    },
    formatDateInicial() {
      if (!this.filtro.dataInicial) return null;
      const [year, month, day] = this.filtro.dataInicial.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateFinal() {
      if (!this.filtro.dataFinal) return null;
      const [year, month, day] = this.filtro.dataFinal.split("-");
      return `${day}/${month}/${year}`;
    },
    disabledLeft() {
      if (this.filtro.page == 1) {
        return true;
      }
    },
    ultimos() {
      return this.getUltimosAgendamentos;
    }
  },
  watch: {},
  async mounted() {
    if (sessionStorage.getItem("dia")) {
      let dia = sessionStorage.getItem("dia");
      sessionStorage.removeItem("dia");
      (this.filtro.dataInicial = moment(dia).format("YYYY-MM-DD") + "T00:00"),
        (this.filtro.dataFinal = moment(dia).format("YYYY-MM-DD") + "T23:59"),
        (this.isLoadingBusca = true);
      let resp = await this.setUltimosAgendamentos(this.filtro);
      this.isLoadingBusca = false;
      return resp;
    } else this.getAgendamentos();
  }
};
</script>

<style scoped>
.flex-container {
  display: flex;
  flex-wrap: nowrap;
}
</style>





// WEBPACK FOOTER //
// src/components/user/mensagens/ListarCampanhas.vue